import { apiClient } from "./apiClient";

export const SF_PHANBOPHI_SELECT_BY_SCT = "sf_phanbophi/select_by_sct";
export const SF_PHANBOPHI_SAVECHANGES = "sf_phanbophi/savechanges";
export const SF_PHANBOPHI_SAVEFINISH = "sf_phanbophi/finish";
export const SF_PHANBOPHI_DELETE = "sf_phanbophi/delete";
export const SF_PHANBOPHI_UPDATE_PAYMENT_METHOD = "sf_phanbophi/update_payment_method";
export const SF_PHANBOPHI_SELECT_PAYMENT_REPORT =
  "sf_phanbophi/select_payment_report";

export const phanBoPhiApi = {
  select_by_sct: (sf_mucphaithu_id: number) =>
    apiClient.post(
      `${SF_PHANBOPHI_SELECT_BY_SCT}?sf_mucphaithu_id=${sf_mucphaithu_id}`
    ),
  save_changes: (data: any) =>
    apiClient.post(`${SF_PHANBOPHI_SAVECHANGES}`, data),
  delete: (id: number) => apiClient.post(`${SF_PHANBOPHI_DELETE}`, id),
  update_payment_method: (id: number, sf_hinhthucthanhtoan_old_id: number, sf_hinhthucthanhtoan_id: number) =>
    apiClient.post(
      `${SF_PHANBOPHI_UPDATE_PAYMENT_METHOD}?id=${id}&sf_hinhthucthanhtoan_old_id=${sf_hinhthucthanhtoan_old_id}&sf_hinhthucthanhtoan_id=${sf_hinhthucthanhtoan_id}`
    ),
  save_finish: (
    sf_mucphaithu_id: number,
    ngaythu: Date,
    nam_hoc_dong_phi: string
  ) =>
    apiClient.post(
      `${SF_PHANBOPHI_SAVEFINISH}?sf_mucphaithu_id=${sf_mucphaithu_id}&ngaythu=${ngaythu}&nam_hoc_dong_phi=${nam_hoc_dong_phi}`
    ),
  select_payment_report: (data: any) =>
    apiClient.post(`${SF_PHANBOPHI_SELECT_PAYMENT_REPORT}`, data),
  SelectDashBoard: (request: any) =>
    apiClient.post(`sf_phanbophi/dashboard`, request),
};
